/**
 * LifeThemeExpressPage
 * Karusell med 5 slumpade frågor från olika livsteman
 * Användaren kan ladda nya frågor eller klicka på en fråga för att börja svara
 */

import React, { useEffect } from 'react';
import { trackEvent } from '../utils/analytics';
import LifeThemeQuestionCarousel from '../components/LifeThemeQuestionCarousel';

const LifeThemeExpressPage = () => {
  useEffect(() => {
    // Track page view (public carousel)
    trackEvent('Life Theme Express Page View Public', {
      location: 'life-theme-express-page',
      source: 'landing-page',
      flow_type: 'public_carousel'
    });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-surface-primary to-surface-secondary font-sans mt-4">
      <div className="max-w-4xl mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Utforska dina livsteman
          </h1>
          <p className="text-xl text-secondary max-w-2xl mx-auto leading-relaxed">
            Välj ett påstående som du tycker passar in på dig för att få djupare insikter om dina livsteman.
          </p>
        </div>

        {/* Question Carousel Component */}
        <LifeThemeQuestionCarousel source="express-page" />
      </div>
    </div>
  );
};

export default LifeThemeExpressPage;
